<script setup lang="ts"></script>

<template>
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_233_15762)">
            <path
                d="M0.75 1.25V3.75H23.25V1.25H0.75ZM0.75 5V18.75H23.25V5H0.75ZM3.25 16.25L4.5 13.75H10.75L12 16.25H3.25ZM7.625 7.5C8.28804 7.5 8.92393 7.76339 9.39277 8.23223C9.86161 8.70107 10.125 9.33696 10.125 10C10.125 10.663 9.86161 11.2989 9.39277 11.7678C8.92393 12.2366 8.28804 12.5 7.625 12.5C6.96196 12.5 6.32607 12.2366 5.85723 11.7678C5.38839 11.2989 5.125 10.663 5.125 10C5.125 9.33696 5.38839 8.70107 5.85723 8.23223C6.32607 7.76339 6.96196 7.5 7.625 7.5ZM14.5 7.5H15.125H20.125H20.75V8.75H20.125H15.125H14.5V7.5ZM14.5 10H15.125H20.125H20.75V11.25H20.125H15.125H14.5V10ZM14.5 12.5H15.125H20.125H20.75V13.75H20.125H15.125H14.5V12.5Z"
                fill="white"
            />
        </g>

        <defs>
            <clipPath id="clip0_233_15762">
                <rect
                    width="22.5"
                    height="20"
                    fill="white"
                    transform="translate(0.75)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
